window.logDev = function (...payload) {
};
